export function section08() {
    let livingRoomScreenshot = document.querySelector(
        ".section.slice-8 #living-room-screenshot img"
    )
    gsap.timeline({
        repeat: -1,
        repeatDelay: 1,
        yoyo: false,
        defaults: { duration: 3.5, ease: "expo.inOut" },
        scrollTrigger: {
            trigger: ".section.slice-8",
            start: "center bottom",
            scrub: false,
            // pin: true,
        },
    })
        .to(livingRoomScreenshot, {
            y: "-10%",
        })
        .to(
            livingRoomScreenshot,
            {
                y: "-28%",
            },
            ">+0.5"
        )
        .to(
            livingRoomScreenshot,
            {
                y: "-48%",
            },
            ">+0.35"
        )
        .to(
            livingRoomScreenshot,
            {
                y: "-70%",
            },
            ">+0.25"
        )
        .to(
            livingRoomScreenshot,
            {
                y: "-90%",
            },
            ">+0.5"
        )
        .to(
            livingRoomScreenshot,
            {
                y: "0",
                duration: 3,
                ease: "back.out(0.55)",
            },
            ">+1"
        )
}
